export default [
    /* Sonda - Báo cáo của Sở */
    {
        path: "briefingcollections",
        name: "Báo cáo của Sở",
        redirect: "briefingcollections/list",
        component: {
            render(c) {
                return c("router-view");
            },
        },
        children: [
            {
                path: "list",
                name: "Danh sách báo cáo",
                component: () =>
                    import(
                        "@/views/screens/briefingCollections/BriefingsCollectionRP"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Tra cứu báo cáo của Sở"
                },
            },
            {
                path: "create",
                name: "Thêm báo cáo",
                component: () =>
                    import(
                        "@/views/screens/briefingCollections/BriefingsCollectionRPCreate"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Thêm báo cáo"
                },
            },
            {
                path: "edit/:id",
                name: "Sửa nội dung báo cáo",
                component: () =>
                    import(
                        "@/views/screens/briefingCollections/BriefingsCollectionRPEdit"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Sửa nội dung báo cáo"
                },
            },
        ],
    },
]